import {Component} from '@angular/core';
import {
    EnrollmentTypeIndicatorComponent
} from "../../../common/enrollment-type-indicator/enrollment-type-indicator.component";
import {FormsModule} from "@angular/forms";
import { MatTableModule } from "@angular/material/table";
import {MatChipsModule} from "@angular/material/chips";
import {MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatInput} from "@angular/material/input";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatSortModule} from "@angular/material/sort";
import {CommonModule} from "@angular/common";
import {StatusIndicatorComponent} from "../../../common/status-indicator/status-indicator.component";
import {SearchType} from "../../../domain/enums/search-type.enum";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {EnrollmentType} from "../../../domain/enums/enrollment-type.enum";
import {CustomerSearchComponent} from "../customer/customer-search/customer-search.component";
import {ReceiptSearchComponent} from "../receipt/receipt-search/receipt-search.component";
import {PropertySearchListComponent} from "../property/property-search-list/property-search-list.component";

@Component({
  selector: 'app-search-page',
  standalone: true,
  imports: [MatTableModule, MatPaginatorModule, MatSortModule, EnrollmentTypeIndicatorComponent,
    StatusIndicatorComponent, FormsModule, MatFormField, MatIcon, MatIconButton, MatInput,
    MatLabel, MatOption, MatSelect, MatSuffix, CommonModule, MatChipsModule, RouterLink, CustomerSearchComponent,
    ReceiptSearchComponent, PropertySearchListComponent],
  templateUrl: './search-page.component.html',
  styleUrl: './search-page.component.css'
})
export class SearchPageComponent {
  searchType: string = SearchType.CUSTOMER;
  protected readonly SearchType = SearchType;
  protected readonly Object = Object;
  protected readonly EnrollmentType = EnrollmentType;

  constructor(private route: ActivatedRoute) {
    this.route.data.subscribe(data => {
      const searchType = data['searchType'];
      if(searchType) {
        this.searchType = data['searchType'];
      }
    });
  }
}
